import { render, staticRenderFns } from "./PdvDeliveryObject.vue?vue&type=template&id=5079a662"
import script from "./PdvDeliveryObject.vue?vue&type=script&lang=js"
export * from "./PdvDeliveryObject.vue?vue&type=script&lang=js"
import style0 from "./PdvDeliveryObject.vue?vue&type=style&index=0&id=5079a662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports